import { memo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import BidList from './pages/bid/BidList';
import BidGroup from './pages/bid/BidGroup';
import BidRegister from './pages/bid/BidRegister';
import BidManager from './pages/bid/BidManager';
import BidPreRegister from './pages/bid/BidPreRegister';
import DeliveryList from './pages/bid/DeliveryList';
import BidHistory from './pages/entry/BidHistory';
import BidListMonitor from './pages/signnage/BidListMonitor';
import BidHistoryMonitor from './pages/signnage/BidHistoryMonitor';
import ShipList from './pages/maintenance/ShipList';
import TraderList from './pages/maintenance/TraderList';
import FishSpecList from './pages/maintenance/FishSpecList';
import UserList from './pages/maintenance/UserList';
import StandardList from './pages/maintenance/StandardList';
import FishMethodList from './pages/maintenance/FishMethodList';
import MemoList from './pages/maintenance/MemoList';
import OriginalFishSpecList from './pages/maintenance/OriginalFishSpecList';
import OriginalShipList from './pages/maintenance/OriginalShipList';
import Home from './pages/Home';
import BidMastaMenu from './pages/menu/BidMastaMenu';
import SystemMastaMenu from './pages/menu/SystemMastaMenu';
import SignageMenu from './pages/menu/SignageMenu';
import CommentList from './pages/maintenance/CommentList';
import BidPersonList from './pages/maintenance/BidPersonList';
import DanbeList from './pages/maintenance/DanbeList';
import HomeMobile from './pages/mobile/Home';
import BidGroupMobile from './pages/mobile/BidGroup';
import BidManagerMobile from './pages/mobile/BidManager';
import BidRegisterMobile from './pages/mobile/BidRegister';
import UnloadList from './pages/terminal/UnloadList';
import UnloadDataList from './pages/dataInput/UnloadDataList';
import BidDataList from './pages/dataInput/BidDataList';
import Mobile from './pages/Mobile';

const AppRouter = memo(() => {
  return (
    <Router>
        <Routes>
            <Route path="/"                     element={<Login />} />
            <Route path="/mobile"               element={<Mobile />} />
            <Route path="/home"                 element={<Home />} />
            <Route path="/bidMastaMenu"         element={<BidMastaMenu />} />
            <Route path="/systemMastaMenu"      element={<SystemMastaMenu />} />
            <Route path="/signageMenu"          element={<SignageMenu />} />
            <Route path="/unloadList"           element={<UnloadList />} />
            <Route path="/bidList"              element={<BidList />} />
            <Route path="/bidGroup"             element={<BidGroup />} />
            <Route path="/bidRegister"          element={<BidRegister />} />
            <Route path="/bidManager"           element={<BidManager />} />
            <Route path="/bidPreRegister"       element={<BidPreRegister />} />
            <Route path="/deliveryList"         element={<DeliveryList />} />
            <Route path="/unloadDataList"       element={<UnloadDataList />} />
            <Route path="/bidDataList"          element={<BidDataList />} />
            <Route path="/bidHistory"           element={<BidHistory />} />
            <Route path="/bidListMonitor"       element={<BidListMonitor />} />
            <Route path="/bidHistoryMonitor"    element={<BidHistoryMonitor />} />
            <Route path="/shipList"             element={<ShipList />} />
            <Route path="/standardList"         element={<StandardList />} />
            <Route path="/traderList"           element={<TraderList />} />
            <Route path="/fishSpecList"         element={<FishSpecList />} />
            <Route path="/bidPersonList"        element={<BidPersonList />} />
            <Route path="/commentList"          element={<CommentList />} />
            <Route path="/memoList"             element={<MemoList />} />
            <Route path="/fishMethodList"       element={<FishMethodList />} />
            <Route path="/userList"             element={<UserList />} />
            <Route path="/originalFishSpecList" element={<OriginalFishSpecList />} />
            <Route path="/originalShipList"     element={<OriginalShipList />} />
            <Route path="/danbeList"            element={<DanbeList />} />
            <Route path="/homeMobile"           element={<HomeMobile />} />
            <Route path="/bidGroupMobile"       element={<BidGroupMobile />} />
            <Route path="/bidManagerMobile"     element={<BidManagerMobile />} />
            <Route path="/bidRegisterMobile"    element={<BidRegisterMobile />} />
            <Route
                path="*"
                element={
                <main>
                    <p>一致するものがありません</p>
                </main>
                }
                />
        </Routes>
    </Router>
  );
});

export default AppRouter;